export const getNavigationDataCacheKey = (
  clientId: string,
  channel: 'web' | 'mob',
  locale: string,
  sliced: boolean,
): string => `nav-data-${clientId}-${locale}-${channel}-${sliced}`;
